define.alias("ember-math-helpers/helpers/mod", "settings/helpers/mod");